import { lazy } from 'react';

const AprrovedIntegrativeCertificationConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/integrative/consult/transfer',
			component: lazy(() => import('./AprrovedCertificationContainer'))
		}
	]
};

export default AprrovedIntegrativeCertificationConfig;

